import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', this.onChange.bind(this));
    this.element.addEventListener('keyup', this.onChange.bind(this));
  }

  onChange() {
    try {
      var cleanValue = this.element.value.replace(/[^\d\.\-]+/g, '');
      var parts = cleanValue.split('.');
      var beforeDecimal = parts[0];
      var afterDecimal = '';
      if (parts.length > 1) {
        afterDecimal = parts[1].substring(0,2);
      }
      var number = parseFloat(beforeDecimal);
      if (!isNaN(number)) {
        var formatted = number.toLocaleString("en-US");
        if (parts.length > 1) {
          formatted += '.' + afterDecimal;
        }
        if (formatted != this.element.value) {
          this.element.value = formatted;
        }  
      }
    } catch (e) {
      // Do nothing here, the value will remain unformatted
    }
  }
}